import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import { SubscriptionObject } from 'app/shared/models/standard.models';
import { SharedDataService } from 'app/shared/services/shared-data.service';
import { DAWASearch } from 'app/shared/utilities/dawa';

@Component({
  selector: 'jublo-zip',
  templateUrl: './zip.component.html',
  styleUrls: ['./zip.component.css']
})
export class ZipComponent implements OnInit, OnDestroy, OnChanges {

  @Input() zip: string;
  @Input() city: string;
  @Input('options') o:any;
  @Output() zipChange = new EventEmitter<string>();
  @Output() cityChange = new EventEmitter<string>();

  options = new ZipOptions();

  companyLanguage: string = 'da-DK';
  searching: boolean = false;
  dawa = new DAWASearch(this.http);
  subscriptions: SubscriptionObject = {};
  noSuchZip:boolean = false;

  constructor(private http: HttpClient, private shared: SharedDataService) { }

  ngOnInit(): void {
    this.subscriptions['language'] = this.shared.companyInformation().subscribe({
      next:(data) => this.companyLanguage = data.companyLanguage
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(!!changes.o && !!changes.o.currentValue){
      for(let x of Object.keys(this.o)){
        this.options[x] = this.o[x]
      }
    }
  }

  ngOnDestroy(): void {
    for(let x of Object.keys(this.subscriptions)) this.subscriptions[x].unsubscribe();
  }

  search(search){
    if(this.companyLanguage != 'da-DK') {
      this.zipChange.emit(search.target.value);
      this.noSuchZip = false;
    }
    else if(this.companyLanguage == 'da-DK' && !!search.target.value && search.target.value.length == 4){
      this.dawa.cityByZip(search.target.value).subscribe({
        next:(data) => {
          this.noSuchZip = false;
          if(!!data && data.length){
            this.zipChange.emit(data[0].nr);
            this.cityChange.emit(data[0].navn);
          }
          else {
            this.noSuchZip = true;
            this.cityChange.emit(null)
          }
        }
      })
    }
  }

}

class ZipOptions {
  classes:string = 'form-control borderless'
}
